import { render, staticRenderFns } from "./PrioritiesForm.vue?vue&type=template&id=ba924d60&"
import script from "./PrioritiesForm.vue?vue&type=script&lang=js&"
export * from "./PrioritiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports